import { useState } from 'react'
import { Bell, ChevronDown } from 'lucide-react'
import { useAuth } from '@/hooks/useAuth'

export const Header = () => {
  const { user, logout } = useAuth()
  const [dropdownOpen, setDropdownOpen] = useState(false)

  return (
     <div className='sticky top-0 z-40 flex h-16 shrink-0 items-center gap-x-4 border-b border-gray-200 bg-white px-4 shadow-sm sm:gap-x-6 sm:px-6 lg:px-8'>
        <div className='flex flex-1 gap-x-4 self-stretch lg:gap-x-6'>
           <div className='flex flex-1'></div>
           <div className='flex items-center gap-x-4 lg:gap-x-6'>
              {/* Notifications */}
              <button type='button' className='-m-2.5 p-2.5 text-gray-400 hover:text-gray-500'>
                 <span className='sr-only'>View notifications</span>
                 <Bell className='h-6 w-6' aria-hidden='true' />
              </button>

              {/* Separator */}
              <div className='hidden lg:block lg:h-6 lg:w-px lg:bg-gray-200' aria-hidden='true' />

              {/* Profile dropdown */}
              <div className='relative'>
                 <button
                    onClick={() => setDropdownOpen(!dropdownOpen)}
                    className='-m-1.5 flex items-center p-1.5 hover:bg-gray-50 rounded-lg'
                 >
                    <span className='sr-only'>Open user menu</span>
                    <img
                       className='h-8 w-8 rounded-full bg-gray-50'
                       src={`https://ui-avatars.com/api/?name=${user?.firstName}+${user?.lastName}&background=3b82f6&color=fff`}
                       alt=''
                    />
                    <span className='hidden lg:flex lg:items-center'>
                       <span
                          className='ml-4 text-sm font-semibold leading-6 text-gray-900'
                          aria-hidden='true'
                       >
                          {user?.firstName} {user?.lastName}
                       </span>
                       <ChevronDown className='ml-2 h-5 w-5 text-gray-400' aria-hidden='true' />
                    </span>
                 </button>

                 {dropdownOpen && (
                    <div className='absolute right-0 z-10 mt-2.5 w-32 origin-top-right rounded-md bg-white py-2 shadow-lg ring-1 ring-gray-900/5 focus:outline-none'>
                       <button
                          onClick={logout}
                          className='block px-3 py-1 text-sm leading-6 text-gray-900 w-full text-left hover:bg-gray-50'
                       >
                          Sign out
                       </button>
                    </div>
                 )}
              </div>
           </div>
        </div>
     </div>
  );
} 